import { CONSTANT } from '@const';
import { DqpAccountType, DqpRegistrationPayload } from '@types';

import { ApiParams, ApiService } from '../api/ApiService';

export class DqpAccountService extends ApiService {
	protected static baseUrl = CONSTANT.DQP_API_BASE_URL;
	static async getDqpAccount(): Promise<DqpAccountType> {
		const params: ApiParams = {
			method: 'GET',
			url: CONSTANT.DQP_USER_API_URL,
		};
		return await this.executeApiRequest(params).then((data: DqpAccountType) => {
			return data;
		});
	}

	static async updateDqpAccount(dqpAccount: Partial<DqpAccountType>): Promise<DqpAccountType> {
		const params: ApiParams = {
			method: 'PUT',
			url: CONSTANT.DQP_USER_API_URL,
			data: { ...dqpAccount },
		};
		return await this.executeApiRequest(params);
	}

	static async registerDqpAccount(payload: DqpRegistrationPayload): Promise<boolean> {
		const params: ApiParams = {
			method: 'POST',
			url: CONSTANT.DQP_LICENCE_API_URL,
			data: payload,
		};
		return await this.executeApiRequest(params);
	}

	static async closeAccount(): Promise<void> {
		const params: ApiParams = {
			method: 'DELETE',
			url: CONSTANT.DQP_LICENCE_API_URL,
		};
		return await this.executeApiRequest(params);
	}
}
